export default class Operation {
  constructor() {
    this._items = [];
    this._loading = false;
  }

  get(){
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }
  set(data){
    this._items = data.map(item=>{
      return {
        id: item.ID,
        value: item.ID,
        name: item.Name,
        label: item.Name,
        direction: item.InOut,
        category: item.PaymentTypeCategoryId,
        type: item.PaymentTypeId,
        reason: item.PaymentFor,
        agreement: item.OperationType,
        bonuses: item.IsBonusesPayment,
      }
    });
  }
  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}